export interface IUserResource extends ng.resource.IResourceClass<any> {
  fullname: String;
  email: String;
  password: String;
  contact: String;
  userType: String;
  purpose: String;
  category: String;
  first_login: Boolean;
  password_reset: Boolean;
  organization: IOrganization;
  ministry: any;
  agency: any;
  state: String;
  update: Function;
  updateAll: Function;
  approve: Function;
  reject: Function;
  revoke: Function;
}
interface IOrganization {
  name: String;
  org_type: String;
}

export class UserService {
  public static $inject: Array<string> = ["$resource"];
  public userService: ng.resource.IResourceClass<any>;
  constructor(private $resource: any) {
    let userService =  $resource(`${BASE}/api/user/:userId`, {userId: '@id'}, {
      update: {
        method: "PUT"
      },
      updateAll: {
        method: "PATCH",
        isArray: true
      },
      approve: {
        method: "POST",
        url: "/api/user/approve",
        isArray: true
      },
      reject: {
        method: "POST",
        url: "/api/user/reject",
        isArray: true
      },
      revoke: {
        method: "POST",
        url: "/api/user/revoke",
        isArray: true
      }
    });
    this.userService = userService;
    return userService;
  }
}
